/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_CLIENT_FAULT_GROUPS } from '../../actions.type'
import {
  CREATE_CLIENT_FAULT_GROUP,
  REMOVE_CLIENT_FAULT_GROUP,
  SET_CLIENT_FAULT_GROUP_ALL_REQUEST,
  SET_CLIENT_FAULT_GROUP_ALL_VALUE,
  UPDATE_CLIENT_FAULT_GROUP
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  clientFaultGroupAllValue: (state) => state.all.value,
  clientFaultGroupAllRequest: (state) => state.all.request,
  clientFaultGroupAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_CLIENT_FAULT_GROUPS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('client-fault-group', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_CLIENT_FAULT_GROUP_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_CLIENT_FAULT_GROUP_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_CLIENT_FAULT_GROUP_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_CLIENT_FAULT_GROUP_ALL_VALUE, data)
    } catch (e) {
      commit(SET_CLIENT_FAULT_GROUP_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_CLIENT_FAULT_GROUP({ commit }, value) {
    commit(CREATE_CLIENT_FAULT_GROUP, value)
  },

  async SOCKET_UPDATE_CLIENT_FAULT_GROUP({ commit }, value) {
    commit(UPDATE_CLIENT_FAULT_GROUP, value)
  },

  async SOCKET_REMOVE_CLIENT_FAULT_GROUP({ commit }, id) {
    commit(REMOVE_CLIENT_FAULT_GROUP, id)
  }
}

const mutations = {
  [SET_CLIENT_FAULT_GROUP_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_CLIENT_FAULT_GROUP_ALL_VALUE](state, clientFaultGroups) {
    state.all.value = clientFaultGroups
  },
  [UPDATE_CLIENT_FAULT_GROUP](state, updatedClientFaultGroup) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedClientFaultGroup.id }),
      1,
      updatedClientFaultGroup
    )
  },
  [CREATE_CLIENT_FAULT_GROUP](state, createdClientFaultGroup) {
    state.all.value.push(createdClientFaultGroup)
  },
  [REMOVE_CLIENT_FAULT_GROUP](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
